import React from 'react';
import {ContMain} from '../styles/components/main-content.styles';

const ContenidoMain = ({children}) => {
    return (  
        <ContMain>
            {children}
        </ContMain>
    );
}
 
export default ContenidoMain;